import { BALLOON_PEAK, BALLOON_RADIUS, BALLOON_TOP_MARGIN, GOLD_SPAWN_CHANCE, WORLD_WIDTH, standingGroundY } from "../game/constants";
import { balloonFlightDuration, maxBalloonsFor, spawnIntervalFor } from "../game/rules";
import { Balloon } from "../entities/Balloon";
import type { BalloonType, DifficultyId, MatchState } from "../game/types";

const TYPES: BalloonType[] = ["blue", "green", "red"];

export class SpawnSystem {
  cooldown = 0.4;

  reset(): void {
    this.cooldown = 0.4;
  }

  update(dt: number, state: MatchState, balloons: Balloon[], forced?: BalloonType): Balloon | null {
    const alive = balloons.filter((b) => b.alive).length;
    const cap = maxBalloonsFor(state.difficulty);
    if (alive >= cap) return null;
    this.cooldown -= dt;
    if (this.cooldown > 0) return null;
    this.cooldown = spawnIntervalFor(state.score);
    const type = forced ?? this.pickType();
    return this.create(type, state);
  }

  create(type: BalloonType, state: MatchState, x?: number): Balloon {
    const minX = 390;
    const maxX = WORLD_WIDTH - 90;
    const spawnX = x ?? minX + Math.random() * (maxX - minX);
    const range = BALLOON_PEAK[type];
    const raw = range.min + Math.random() * (range.max - range.min);
    const ceiling = standingGroundY(spawnX) - BALLOON_RADIUS[type] - BALLOON_TOP_MARGIN;
    const peak = Math.min(raw, Math.max(160, ceiling));
    return new Balloon(type, spawnX, balloonFlightDuration(type, state.score), peak);
  }

  private pickType(): BalloonType {
    if (Math.random() < GOLD_SPAWN_CHANCE) return "gold";
    return TYPES[Math.floor(Math.random() * TYPES.length)] ?? "green";
  }
}

export function canSpawnMore(difficulty: DifficultyId, active: number): boolean {
  return active < maxBalloonsFor(difficulty);
}
